export default (props, vars) => props?.['student']?.finalPresentation?.id;
